// extracted by mini-css-extract-plugin
export default {"header":"XmDbN2329AjCHdNAhPZw","title":"JMxvXo0c8kLBgiN0X7ZZ"};